import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  OTP_SIGN_IN,
  TERMS_CONDITION,
  PRIVACY_POLICY,
  SALON_DETAILS_ROUTE,
  SALON_LIST_ROUTE,
  SIDEMENU,
  OTP_LOGIN,
  REFERAL,
  MY_BOOKINGS,
} from '../../constants';
import { getCookie } from '../../utils';
import PropTypes from 'prop-types';

class Authenticator extends React.Component {
  componentDidMount() {
    const accessToken = getCookie('accessToken');
    if (
      window.location.pathname === TERMS_CONDITION ||
      window.location.pathname === SALON_LIST_ROUTE ||
      window.location.pathname === PRIVACY_POLICY ||
      window.location.pathname === MY_BOOKINGS ||
      window.location.pathname === SIDEMENU ||
      window.location.pathname === REFERAL ||
      window.location.pathname === OTP_LOGIN ||
      window.location.pathname.indexOf(SALON_DETAILS_ROUTE) > -1
    ) {
      return;
    }
    if (
      window.location.pathname === '/' ||
      window.location.pathname === OTP_SIGN_IN
    ) {
      if (accessToken) {
        this.props.history.push(this.props.fallBackRoute);
      }
      return;
    }
    if (!accessToken) {
      this.props.history.push(this.props.fallBackRoute);
    }
  }

  componentDidUpdate() {
    const accessToken = getCookie('accessToken');
    if (
      window.location.pathname === TERMS_CONDITION ||
      window.location.pathname === SALON_LIST_ROUTE ||
      window.location.pathname === MY_BOOKINGS ||
      window.location.pathname === PRIVACY_POLICY ||
      window.location.pathname === REFERAL ||
      window.location.pathname === SIDEMENU ||
      window.location.pathname === OTP_LOGIN ||
      window.location.pathname.indexOf(SALON_DETAILS_ROUTE) > -1
    ) {
      return;
    }
    if (
      window.location.pathname === '/' ||
      window.location.pathname === OTP_SIGN_IN
    ) {
      if (accessToken) {
        this.props.history.push(this.props.fallBackRoute);
      }
      return;
    }
    if (!accessToken) {
      this.props.history.push(this.props.fallBackRoute);
    }
  }

  render() {
    return <div>{this.props.component}</div>;
  }
}

Authenticator.propTypes = {
  history: PropTypes.shape(),
  fallBackRoute: PropTypes.string,
  component: PropTypes.node,
};

export default withRouter(Authenticator);
